import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from "./context/AuthContext";
import { MobileModeProvider } from "./context/MobileModeContext"; // ✅ tambahkan ini

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <AuthProvider>
      <MobileModeProvider>   {/* ✅ bungkus di sini */}
        <App />
      </MobileModeProvider>
    </AuthProvider>
  </React.StrictMode>
);

reportWebVitals();
